
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Tooltip } from '@radix-ui/themes'
import { useState, useRef, useEffect } from 'react'

const EllipsisWithTooltip = ({ children }: { children: any }) => {
  const textRef = useRef<HTMLDivElement>(null)
  const [isOverflowing, setIsOverflowing] = useState(false)

  useEffect(() => {
    const element = textRef.current
    if (!element) return
    if (element) {
      setIsOverflowing(element.scrollWidth > element.clientWidth)
    }
  }, [children])

  const textElement = (
    <div ref={textRef} className="overflow-hidden whitespace-nowrap text-ellipsis">
      {children}
    </div>
  )

  return isOverflowing ? <Tooltip content={children}>{textElement}</Tooltip> : textElement
}

export default EllipsisWithTooltip
